export enum AlertsEditorMode {
  edit = 0,
  create = 1,
  fromQuery = 2,
}
